import React, { useState } from "react";
import { BsSun, BsMoon } from "react-icons/bs";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import { Link } from "react-scroll";
import { useTheme } from "../context/ThemeContext";
import { AnimatePresence, motion } from "framer-motion";

const NavBar = () => {
  const { theme, toggleTheme } = useTheme();
  const [open, setOpen] = useState(false);

  const links = [
    { id: 1, link: "Home" },
    { id: 2, link: "About" },
    { id: 3, link: "Portfolio" },
    { id: 4, link: "Skills" },
    { id: 6, link: "Contact" },
  ];

  return (
    <nav className="fixed inset-x-0 top-0 z-50 h-16 border-b border-slate-200 bg-white/95 px-5 transition-colors duration-300 dark:border-zinc-800 dark:bg-[#09090b]/95 sm:px-6">
      <div className="mx-auto flex h-full max-w-6xl items-center justify-between">
        <Link to="Home" smooth duration={500} onClick={() => setOpen(false)}>
          <span className="cursor-pointer text-lg font-bold text-slate-900 dark:text-white">
            Aakash Anand
          </span>
        </Link>

        <ul className="hidden items-center gap-7 md:flex">
          {links.map(({ id, link }) => (
            <li key={id} className="relative text-sm font-medium text-slate-600 dark:text-zinc-300">
              <Link
                to={link}
                smooth
                spy
                offset={-64}
                duration={500}
                activeClass="text-indigo-600 dark:text-indigo-400 after:absolute after:-bottom-1.5 after:left-0 after:right-0 after:h-0.5 after:rounded-full after:bg-indigo-600 dark:after:bg-indigo-400"
                className="relative cursor-pointer px-1 py-2 transition-colors hover:text-indigo-600 dark:hover:text-indigo-400"
              >
                {link}
              </Link>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={toggleTheme}
            className="grid h-9 w-9 place-items-center rounded-full border border-slate-200 text-slate-700 transition-colors hover:bg-slate-50 dark:border-zinc-800 dark:text-zinc-200 dark:hover:bg-zinc-900"
            title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
          >
            {theme === "dark" ? <BsSun size={16} /> : <BsMoon size={16} />}
          </button>

          <button
            type="button"
            aria-label="Toggle menu"
            onClick={() => setOpen((prev) => !prev)}
            className="grid h-9 w-9 place-items-center rounded-full border border-slate-200 text-slate-700 dark:border-zinc-800 dark:text-zinc-200 md:hidden"
          >
            {open ? <HiX size={20} /> : <HiMenuAlt3 size={20} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.15 }}
            className="absolute left-4 right-4 top-[calc(100%+8px)] panel p-3 md:hidden"
          >
            <div className="grid gap-1">
              {links.map(({ id, link }) => (
                <Link
                  key={id}
                  to={link}
                  smooth
                  spy
                  offset={-64}
                  duration={500}
                  onClick={() => setOpen(false)}
                  activeClass="bg-indigo-50 text-indigo-600 dark:bg-indigo-500/10 dark:text-indigo-400"
                  className="cursor-pointer rounded-xl px-4 py-3 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 dark:text-zinc-200 dark:hover:bg-zinc-900"
                >
                  {link}
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default NavBar;
